import React from 'react';
import { Sparkles } from 'lucide-react';
import { useI18n } from '../i18n';

export default function Login() {
  const { t, toggle, lang } = useI18n();

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen w-full flex flex-col lg:flex-row overflow-hidden">
      {/* Left brand panel */}
      <div className="relative lg:w-1/2 min-h-[320px] lg:min-h-screen overflow-hidden flex flex-col justify-between p-8 lg:p-14"
        style={{ background: 'linear-gradient(150deg, #4F46E5 0%, #5B4FD6 45%, #6D5AE0 100%)' }}>
        <div className="absolute -top-24 -left-16 w-[420px] h-[420px] rounded-full bg-white/10 blur-3xl animate-float-grad" />
        <div className="absolute bottom-0 right-0 w-[360px] h-[360px] rounded-full bg-fuchsia-400/20 blur-3xl animate-float-grad" />
        <div className="relative flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-white/15 backdrop-blur flex items-center justify-center ring-1 ring-white/25">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="text-white font-display font-bold text-lg tracking-tight">{t('brand')}</span>
        </div>

        <div className="relative max-w-lg">
          <h1 className="font-display text-white font-extrabold text-4xl lg:text-5xl leading-[1.1] tracking-tight">
            {t('heroTitle')}
          </h1>
          <p className="mt-6 text-indigo-100/90 text-sm lg:text-[15px] leading-relaxed font-medium">
            {t('quote')}
          </p>
          <div className="mt-10 flex items-end gap-9">
            <div>
              <div className="font-display text-white text-3xl lg:text-4xl font-extrabold">100</div>
              <div className="text-indigo-200 text-xs mt-1">{t('totalUseCases')}</div>
            </div>
            <div>
              <div className="font-display text-white text-3xl lg:text-4xl font-extrabold">5</div>
              <div className="text-indigo-200 text-xs mt-1">{t('fiveLayer')}</div>
            </div>
            <div>
              <div className="font-display text-white text-3xl lg:text-4xl font-extrabold">EN/AR</div>
              <div className="text-indigo-200 text-xs mt-1">{t('rtl')}</div>
            </div>
          </div>
        </div>

        <div className="relative text-indigo-200/70 text-xs">{t('appName')}</div>
      </div>

      {/* Right form panel */}
      <div className="lg:w-1/2 flex flex-col bg-slate-50 relative">
        <div className="flex justify-end p-6">
          <button onClick={toggle}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-slate-200 text-slate-700 text-sm font-medium shadow-sm hover:border-indigo-300 hover:text-indigo-600 transition-colors">
            <span className="text-base leading-none">A۷</span>
            {t('langToggle')}
          </button>
        </div>
        <div className="flex-1 flex items-center justify-center px-6 pb-16">
          <div className="w-full max-w-sm animate-fade-up">
            <h2 className="font-display text-3xl font-extrabold text-slate-900">{t('welcomeBack')}</h2>
            <p className="mt-2 text-slate-500 text-sm">{t('signInSub')}</p>

            <button onClick={handleGoogle}
              className="mt-8 w-full flex items-center justify-center gap-3 h-12 rounded-xl bg-white border border-slate-200 text-slate-700 font-semibold shadow-sm hover:shadow-md hover:border-slate-300 active:scale-[0.99] transition-all">
              <GoogleIcon />
              {t('continueGoogle')}
            </button>

            <div className="mt-6 rounded-xl bg-indigo-50/70 border border-indigo-100 px-4 py-3">
              <p className="text-center text-xs text-indigo-500/90 leading-relaxed">{t('adminNote')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg className="w-5 h-5" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
  );
}
